import type { Article } from "../../../types/content";

import styles from "./ArticleSearchList.module.scss";
import { Teaser } from "../../Teaser/Teaser";
import { TeaserCluster } from "../../TeaserCluster/TeaserCluster";
import { mapTeaserStyle } from "../utils/mapTeaserStyle";
import { SearchError } from "../../Discover/SearchError";

export function ArticleSearchList({
  articles,
  searchQuery,
}: {
  articles?: Array<Article>;
  searchQuery: string;
}) {
  if (!articles || articles.length === 0) {
    return (
      <SearchError
        title={`Det verkar inte finnas några artiklar som matchar din sökning på "${searchQuery}"`}
        text="Försök med ord som kan förekomma i texten eller rubriken."
      />
    );
  }

  return (
    <>
      {articles.map((article, i) => (
        <div
          key={`article-${article.article_id}`}
          className={i !== 0 ? styles.teaserClusterDivider : ""}
        >
          <TeaserCluster
            style={mapTeaserStyle([article])}
            header={
              article?.story_vignette
                ? [{ ...article?.story_vignette, type: "StoryVignette" }]
                : []
            }
            footer={[]}
            hasCardStyling={false}
            isSmallCluster={true}
          >
            <Teaser
              article={article}
              positionInFeed={i + 1}
              inCluster={false}
            />
          </TeaserCluster>
        </div>
      ))}
    </>
  );
}
